var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.7207 3.70638H23.4847V1.23438H21.0127V3.70638H8.65266V1.23438H6.18066V3.70638H4.94466C3.58506 3.70638 2.47266 4.81878 2.47266 6.17838V25.9544C2.47266 27.314 3.58506 28.4264 4.94466 28.4264H24.7207C26.0803 28.4264 27.1927 27.314 27.1927 25.9544V6.17838C27.1927 4.81878 26.0803 3.70638 24.7207 3.70638ZM24.7207 25.9544H4.94466V12.3584H24.7207V25.9544ZM24.7207 9.88638H4.94466V6.17838H24.7207V9.88638Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback1);
export default __webpack_public_path__ + "static/media/Feedback1.ee23b5580d7a9008902984bc3907078e.svg";
export { ForwardRef as ReactComponent };